import { formatField } from './formatField';

interface DeltaInsertOp {
  insert: any;
  attributes: any;
}

interface IDataContext {
  [key: string]: string | number;
}

export class InlineValue {
  deltaOp: DeltaInsertOp;
  fieldName?: string;

  protected constructor(deltaOp: DeltaInsertOp) {
    this.deltaOp = deltaOp;
    this.fieldName = deltaOp.insert?.value?.fieldName;
  }

  static create = (deltaOp: DeltaInsertOp) => {
    return new InlineValue(deltaOp);
  };

  public resolveFields = (dataContext: IDataContext, fallbackStr: string = 'No data available', content?: any) => {
    let inlineStr = '';
    const options = this.deltaOp.insert.value;
    const { fieldName, format } = options;
    if (!this.fieldName || !dataContext || dataContext[this.fieldName] === undefined || dataContext[this.fieldName] === null) {
      inlineStr = fallbackStr; // content?.typeSpecific.noDataMessages?.inline;
    } else {
      let inputLocale = 'de-DE';
      const inputField = content?.typeSpecific.fields[fieldName];
      if (inputField) {
        inputLocale = inputField.format.locale;
      }

      inlineStr = formatField(dataContext[this.fieldName], format, true, inputLocale);
    }

    return inlineStr;
  };
}
